import { colors } from '../../colors';
var location = {
  bgColor: colors.whiteish,
  cardBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardShadow: colors.black
};
export default location;